import { BiCheckSquare } from 'react-icons/bi';
import { BsDot } from 'react-icons/bs';
import { MdArchive, MdCallSplit, MdDone, MdUnarchive } from 'react-icons/md';
import { RiStickyNoteLine } from 'react-icons/ri';
import { styled } from 'styles';

export const TransactionArchive = styled(MdArchive)`
  color: ${({ theme }) => theme.transaction.action.archive};
`;

export const TransactionArchived = styled(MdArchive)`
  color: ${({ theme }) => theme.transaction.status.archived};
`;

export const TransactionMatch = styled(BiCheckSquare)`
  color: ${({ theme }) => theme.transaction.action.match.toString()};
`;

export const TransactionMatched = styled(MdDone)`
  color: ${({ theme }) => theme.transaction.status.matched};
`;

export const TransactionNotes = styled(RiStickyNoteLine)`
  color: ${({ theme }) => theme.severity.positive};
  font-size: 0.7em;
`;

export const TransactionRestore = styled(MdUnarchive)`
  color: ${({ theme }) => theme.transaction.action.restore};
`;

export const TransactionUnmatch = styled(MdCallSplit)`
  color: ${({ theme }) => theme.transaction.action.unmatch};
`;

export const TransactionUnmatched = styled(BsDot)`
  color: ${({ theme }) => theme.transaction.status.unmatched};
`;
